import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { Box, Grow, IconButton, InputAdornment, Tooltip } from '@mui/material';
import {
  GridToolbar,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium';
import { useState } from 'react';

import BoltIcon from '@mui/icons-material/Bolt';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import Co2RoundedIcon from '@mui/icons-material/Co2Rounded';
import { useTranslation } from 'react-i18next';

const SeuDatagridToolbar = ({
  setShowCO2,
  setShowYears,
  showCO2,
  showYears,
}) => {
  const [showToolbar, setShowToolbar] = useState(false);

  const { t } = useTranslation('energyxplorer-esg');

  return (
    <GridToolbarContainer
      className="non-printable"
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: 'inherit',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <GridToolbarQuickFilter
          size="small"
          sx={{
            '& .MuiGridToolbarQuickFilter-root': {
              borderRadius: '5px',
              border: '1px solid blue !important',
            },
            '& .MuiInputBase-root': {
              borderRadius: '5px',
            },
            '& .MuiFilledInput-root': {
              borderRadius: '5px',
            },
            '& .MuiInput-underline:before, & .MuiInput-underline:after': {
              display: 'none',
            },
            '& .MuiInputLabel-root': {
              color: 'gray',
            },
          }}
          variant="standard"
          InputProps={{
            placeholder: t('seu_distribution_datagrid.search'),
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon sx={{ color: 'gray' }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Grow in={showToolbar}>
          <GridToolbar />
        </Grow>

        <Tooltip
          title={
            showToolbar
              ? t('seu_distribution_datagrid.hide_settings')
              : t('seu_distribution_datagrid.show_settings')
          }
          placement="top"
        >
          <IconButton
            onClick={() => setShowToolbar(!showToolbar)}
            sx={{ borderRadius: 1 }}
          >
            {showToolbar ? <FilterListOffIcon /> : <FilterListIcon />}
          </IconButton>
        </Tooltip>
        <Tooltip
          title={
            showCO2
              ? t('seu_distribution_datagrid.show_consumption')
              : t('seu_distribution_datagrid.show_emission')
          }
          placement="top"
        >
          <IconButton
            onClick={() => setShowCO2(!showCO2)}
            sx={{ borderRadius: 1 }}
          >
            {showCO2 ? <BoltIcon /> : <Co2RoundedIcon />}
          </IconButton>
        </Tooltip>
        <Tooltip
          title={
            showYears
              ? t('seu_distribution_datagrid.show_quarters')
              : t('seu_distribution_datagrid.show_years')
          }
          placement="top"
        >
          <IconButton
            onClick={() => setShowYears(!showYears)}
            sx={{ borderRadius: 1 }}
          >
            {showYears ? (
              <CalendarMonthRoundedIcon />
            ) : (
              <CalendarTodayRoundedIcon />
            )}
          </IconButton>
        </Tooltip>
      </Box>
    </GridToolbarContainer>
  );
};

export default SeuDatagridToolbar;
